import React from 'react';
import { HeartIcon, ClipboardIcon, UserGroupIcon, PencilIcon } from '@heroicons/react/24/solid';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

// Wrapper de compatibilidade — preserva a assinatura original (activeTab).
// Implementação real em shared_items/NavbarBottom.jsx (design-system fase 2/3). Remover em fase 4.
// Import absoluto (era relativo ../../../) — fase 3 de convenções.
// Nota: cor inativa normalizada pra gray-400 (original usava gray-500) — ver docs/design-system/decisions.md.
const TABS = [
  { key: 'summary', label: 'Summary', Icon: HeartIcon },
  { key: 'records', label: 'Records', Icon: ClipboardIcon },
  { key: 'professionals', label: 'Professionals', Icon: UserGroupIcon },
  { key: 'notes', label: 'Notes', Icon: PencilIcon },
];

const NavbarBottom = ({ activeTab, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTab}
    onTabChange={handleTabChange}
    moduleKey="health"
  />
);

export default NavbarBottom;
